import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=04674f28&scoped=true&lang=pug&"
import script from "./tabs.vue?vue&type=script&lang=js&"
export * from "./tabs.vue?vue&type=script&lang=js&"
import style0 from "./tabs.vue?vue&type=style&index=0&id=04674f28&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04674f28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('04674f28', component.options)
    } else {
      api.reload('04674f28', component.options)
    }
    module.hot.accept("./tabs.vue?vue&type=template&id=04674f28&scoped=true&lang=pug&", function () {
      api.rerender('04674f28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/tabs.vue"
export default component.exports